/** Recovery errors are operator guidance, not a raw HTTP/JSON dump. */
export async function leadRecoveryRequest<T>(url: string, init?: RequestInit): Promise<T> {
  const response = await fetch(url, {
    credentials: "include", ...init,
    headers: { ...(init?.body ? { "Content-Type": "application/json" } : {}), ...init?.headers },
  });
  let body: any = null;
  try { body = await response.json(); } catch { /* explicit unavailable below */ }
  if (!response.ok) {
    throw new Error(typeof body?.error === "string" ? body.error
      : "Recovery prerequisites could not be checked. Retry after verifying the saved account and provider access.");
  }
  return body as T;
}
